import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { DashboardService } from '../../services/dashboard.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { ToastMessageService } from '../../../core/shared-service/toast-message.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css'],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;
  notifications: any;
  tilesList: any = [];
  contentTileList: any = [];
  displayNotifications: any;

  @Output() notifySignUp: EventEmitter<String> = new EventEmitter();
  @Output() displayToast: EventEmitter<String> = new EventEmitter();

  // subscriptions
  private _facilityOnChange: Subscription;

  constructor(
    private rootScopeService: RootScopeService,
    private dashboardService: DashboardService,
    private commonUtil: CommonUtil,
    private toastMessageService: ToastMessageService,
    private _facilityService: FacilityService,
    private router: Router,
    private _amplitudeService: AmplitudeAnalyticsService
  ) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  ngOnInit() {
    this.displayNotifications = {};
    this.displayNotifications.tiles = false;

    this.notifications = {
      tiles: true,
      statEmail: false,
      software: false,
      releaseNotes: false,
    };

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
      this.getDashboardTiles();
      this.generateContentTiles();
    });

    if (this.currentFacility.facilityId) {
      this.getDashboardTiles();
      this.generateContentTiles();
    }
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  setNotificationsExpandStatus(handler: string) {
    setTimeout(() => {
      Object.keys(this.notifications).forEach(v => {
        if (v === handler) { this.notifications[v] = !this.notifications[v]; }
        else { this.notifications[v] = false; }
      });
    }, 500);
  }

  getDashboardTiles() {
   const currentdate: any = new Date().getDate();
   this.dashboardService.getDashboardTileData(this.currentFacility.facilityId, currentdate).subscribe(
      (data: any) => {
        this.generateTilesData(data);
      },
      (error: any) => {
        console.error('API failed.');
      }
    );
  }

  callContentAction(contentType: string) {
    if (contentType === 'software') { this.router.navigate(['/software']); }
    else if (contentType === 'statEmail') { this.enableFacilitySummaryEmail(); }
    else if (contentType === 'releaseNotes') { this.enrollReleaseNotesEmail(); }
  }

  enableFacilitySummaryEmail() {
    this._amplitudeService.logEvent({elementName: 'Sign Up', action: 'Click'}, 'Monthly Insights');
    this.dashboardService.enableFacilitySummaryEmail(this.currentFacility.facilityId).subscribe(
      data => {
        this.currentFacility.summary.statEmail = 'true';
        this.toastMessageService.emitChange(this.commonUtil.translateText('MONTHLY.EQUIPMENT.SIGNUP.SUCCESSFUL'));
        // this.displayToast.emit('MONTHLY.EQUIPMENT.SIGNUP.SUCCESSFUL');
        this.notifySignUp.emit();
        this.rootScopeService.updateRootScope(this.rootScopeData);
        this.generateContentTiles();
      },
      error => {
        console.error('API failed.');
      }
    );
  }

  enrollReleaseNotesEmail() {
    this._amplitudeService.logEvent({elementName: 'Sign Up', action: 'Click'}, 'Release Notes');
    this.dashboardService.enrollReleaseNotesEmail(this.currentFacility.facilityId).subscribe(
      data => {
        this.currentFacility.summary.releaseNotesEmail = 'true';
        this.toastMessageService.emitChange(
          this.commonUtil.translateText('RELEASE.CENTER.DASHBOARD.SIGNUP.SUCCESS.MESSAGE')
        );

        this.notifySignUp.emit();
        // this.displayToast.emit('RELEASE.CENTER.DASHBOARD.SIGNUP.SUCCESS.MESSAGE');
        this.rootScopeService.updateRootScope(this.rootScopeData);
        this.generateContentTiles();
      },
      error => {
        console.error('API failed.');
      }
    );
  }

  generateTilesData(responseData:any): void {
    this.tilesList = [];
    if (this.currentFacility.summary.facilityRights.serviceNotice == 'true') {
      if (responseData.beltCount != null && responseData.beltCount > 0) {
        const tile: any = {};
        tile.tileUrl = 'halo.html#/service/maintenance/inspect_belt';
        tile.maintenanceUrl = responseData.beltUrl; // this url is used by service page
        tile.tileIcon = 'icon-l-equipment-1';
        tile.tileTitle = 'BELT.INSPECTIONS';
        tile.tileCount = responseData.beltCount;
        this.tilesList.push(tile);
      }
      if (responseData.rotationsCount != null && responseData.rotationsCount > 0) {
        const tile: any = {};
        tile.tileUrl = 'halo.html#/service/equipmentRotations';
        tile.maintenanceUrl = responseData.rotationsUrl;
        tile.tileIcon = 'icon-l-rotate';
        tile.tileTitle = 'EQUIPMENT.ROTATIONS';
        tile.tileCount = responseData.rotationsCount;
        this.tilesList.push(tile);
      }

      if (responseData.serviceUpdatesCount != null && responseData.serviceUpdatesCount > 0) {
        const tile: any = {};
        tile.tileUrl = 'halo.html#/service/maintenance/service_ticket';
        tile.maintenanceUrl = responseData.serviceUpdatesUrl;
        tile.tileIcon = 'icon-l-service';
        tile.tileTitle = 'SERVICE.UPDATE';
        tile.countColor = 'idlegreen';
        tile.tileCount = responseData.serviceUpdatesCount;
        this.tilesList.push(tile);
      }
      if (responseData.errorCodeCount != null && responseData.errorCodeCount > 0) {
        const tile: any = {};
        tile.tileUrl = 'halo.html#/service/maintenance/error_codes';
        tile.maintenanceUrl = responseData.errorCodeUrl;
        tile.tileIcon = 'icon-l-warning';
        tile.tileTitle = 'ERROR.CODES';
        tile.countColor = 'idleyellow';
        tile.tileCount = responseData.errorCodeCount;
        this.tilesList.push(tile);
      }
    }

    if (this.currentFacility.summary.facilityRights.calendar == 'true') {
      if (responseData.tasksCount != null && responseData.tasksCount > 0) {
        const tile: any = {};
        tile.tileUrl = 'halo.html#/service/equipmentRotations';
        tile.maintenanceUrl = responseData.tasksUrl;
        tile.tileIcon = 'icon-l-documents';
        tile.tileTitle = 'TASKS.TODAY';
        tile.tileCount = responseData.tasksCount;
        this.tilesList.push(tile);
      }
    }

    if (this.currentFacility.summary.facilityRights.stats == 'true') {
      if (responseData.notConnectedCount != null && responseData.notConnectedCount > 0) {
        const tile: any = {};
        tile.tileUrl = 'halo.html#/stats';
        tile.quickFilterStatus = 'disconnected'; // this status is used by stats page
        tile.tileIcon = 'icon-l-disconnected';
        tile.tileTitle = 'NOT.CONNECTED.EQUIPMENT';
        tile.countColor = 'disconnectedred';
        tile.tileCount = responseData.notConnectedCount;
        tile.tileCount2 = responseData.notConnectedStrengthCount;
        this.tilesList.push(tile);
      }
      if (responseData.idleCount != null && responseData.idleCount > 0) {
        const tile: any = {};
        tile.tileUrl = 'halo.html#/stats';
        tile.quickFilterStatus = 'idle';
        tile.tileIcon = 'icon-s-idle';
        tile.tileTitle = 'IDLE.EQUIPMENT';
        tile.countColor = 'idleyellow';
        tile.tileCount = responseData.idleCount;
        this.tilesList.push(tile);
      }
      if (this.currentFacility.summary.mixedOnboardingFacility == 'true' &&
      this.currentFacility.summary.outdatedOnboardingAssetCount > 0 ) {
        const tile: any = {};
        tile.tileUrl = '/software';
        tile.tileIcon = 'icon-s-timeLine';
        tile.tileTitle = 'OUTDATED.SOFTWARE';
        tile.countColor = 'disconnectedred';
        tile.tileCount = this.currentFacility.summary.outdatedOnboardingAssetCount;
        this.tilesList.push(tile);
      }
    }

    if (this.tilesList != null && this.tilesList.length > 0) { this.displayNotifications.tiles = true; }
  }

  generateContentTiles() {
    this.contentTileList = [];

    if (this.currentFacility.summary.facilityRights.software == 'true') {
      const contentData: any = {};
      contentData.title = 'SOFTWARE.UPDATES';
      if (this.rootScopeData.screenSize === 'xs' || this.rootScopeData.screenSize === 'sm') {
        contentData.titleNew = 'NEW';
        contentData.titleNewClass = 'new-tag';
      } else {
        contentData.titleNew = 'NEW.UPDATE.AVAILABLE';
      }
      contentData.message = 'KEEP.CONSOLES.UPTODATE.MESSAGE';
      contentData.buttonText = 'VIEW';
      contentData.contentAction = 'software';
      contentData.enrolled = false;

      this.contentTileList.push(contentData);
    }

    if (this.currentFacility.summary.statEmail != 'true') {
      const contentData: any = {};
      contentData.title = 'MONTHLY.EQUIPMENT.OVERVIEW';
      contentData.message = 'MONTHLY.EQUIPMENT.OVERVIEW.MESSAGE';
      contentData.buttonText = 'SIGN.UP';
      contentData.contentAction = 'statEmail';
      contentData.enrolled = false;

      this.contentTileList.push(contentData);
    }
  }
}
